import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "bg-white rounded-lg shadow-lg border border-slate-200 w-80 p-3"
};
const _hoisted_2 = {
  class: "flex items-center gap-1 mb-2 border-b border-slate-100 pb-2"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "grid grid-cols-8 gap-0.5 max-h-48 overflow-y-auto"
};
const _hoisted_5 = ["onClick"];
import { ref, computed } from 'vue';
export default {
  __name: 'EmojiPicker',
  emits: ['select'],
  setup(__props) {
    const activeCategory = ref('smileys');
    const categories = [{
      key: 'smileys',
      icon: '😀'
    }, {
      key: 'gestures',
      icon: '👋'
    }, {
      key: 'hearts',
      icon: '❤️'
    }, {
      key: 'objects',
      icon: '📎'
    }, {
      key: 'nature',
      icon: '🌟'
    }];
    const emojiData = {
      smileys: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😋', '😛', '😜', '🤪', '😝', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😮', '😯', '😲', '😳', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '😈', '💀', '💩'],
      gestures: ['👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🫰', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '🫶', '👐', '🤲', '🤝', '🙏'],
      hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '❤️‍🔥', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '♥️', '🫶', '😍', '🥰', '😘', '💋'],
      objects: ['📎', '📌', '📍', '📝', '✏️', '📁', '📂', '📋', '📊', '📈', '📉', '💼', '📧', '📨', '📩', '✉️', '📱', '💻', '⌨️', '🖥️', '📷', '🎥', '📹', '🔔', '🔑', '🔒', '💡', '⏰', '📅', '📆', '✅', '❌'],
      nature: ['🌟', '⭐', '🌙', '☀️', '🌈', '🔥', '💧', '❄️', '🌸', '🌺', '🌻', '🌹', '🍀', '🌿', '🎄', '🌴', '🐶', '🐱', '🐼', '🐨', '🦋', '🐝', '🌊', '🎉', '🎊', '🎁', '🏆', '🥇', '🎯', '💎', '🚀', '💫']
    };
    const currentEmojis = computed(() => emojiData[activeCategory.value] || []);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, cat => {
        return _createElementVNode("button", {
          key: cat.key,
          class: _normalizeClass(["px-2 py-1 text-sm rounded transition-colors cursor-pointer", activeCategory.value === cat.key ? 'bg-primary-50 text-primary-600' : 'text-slate-500 hover:bg-slate-50']),
          onClick: $event => activeCategory.value = cat.key
        }, _toDisplayString(cat.icon), 11, _hoisted_3);
      }), 64))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEmojis.value, emoji => {
        return _openBlock(), _createElementBlock("button", {
          key: emoji,
          class: "w-8 h-8 flex items-center justify-center text-lg rounded hover:bg-slate-100 transition-colors cursor-pointer",
          onClick: $event => _ctx.$emit('select', emoji)
        }, _toDisplayString(emoji), 9, _hoisted_5);
      }), 128))])]);
    };
  }
};